import React from 'react';
import ReactApexChart from 'react-apexcharts';

const BarGraph = ({ pageData }: { pageData: number }) => {
     
    const pageDataInMinutes = parseFloat((pageData / 60).toFixed(2)); 
    function formatMinutes(value: any) {
        const formattedValue = (value).toFixed(2);
        return `${formattedValue}min`;
    }

    
    const options: ApexCharts.ApexOptions = {
        chart: {
            type: 'bar',
            height: 350,
            toolbar: {
                autoSelected: 'zoom', // Enable zoom on the chart
            }
        },
        xaxis: {
            categories: ['1'], // Fixed x-axis label '1'
            labels: {
                rotate: -45,
                offsetY: 40,
            },
        },
        yaxis: {
            labels: {
                formatter: formatMinutes, // Format y-axis labels using the formatMinutes function
            },
        },
        tooltip: {
            y: {
                formatter: function (value) {
                    return `${value.toFixed(2)}min`; // Format tooltip to 2 decimal places
                },
            },
        },
    };

    const series = [
        {
            name: 'Total Time Spent',
            data: [pageDataInMinutes], // Use data in minutes rounded to 2 decimal places
        },
    ];

    return (
        <div className="bar-graph" >
            <ReactApexChart options={options} series={series} type="bar" height={350} />
        </div>
    );
};

export default BarGraph;
